import '../../tables/Table.module.css'

function SimilarityRangeTableEditor(props) {

    const colNames =  ['Factor Name', 'Type', 'Range', 'Similarity Range', 'Unit'];   

    let tableHead = (
        <>
            <tr style={{fontSize: '14px'}}>
                {colNames.map((columnName, index) => (<th key={index} >{columnName}</th>))}
            </tr>
        </>);

    let tableRows = (<></>);

    


    tableRows = props.factors.map((factor, id) => {

//         let slider_min = 0 //Math.log((factor.range_max - factor.range_min)/10000.)
//         let slider_max = factor.range_max-factor.range_min
//         let slider = (<>
//             <input 
//                     id={`similarity_range_slider_${id}`}
//                     type='range'
//                     min={slider_min}
//                     max={slider_max}
//                     // min={0}
//                     // max={3}
//                     step={((slider_max - slider_min)/100000.)}
//                     // step={0.1}
//                     value={props.similarity_range[id] !== null ? props.similarity_range[id] : ''} 
//                     // value={Math.log(props.similarity_range[id]) !== null ? props.similarity_range[id] : ''} 
//                     // value={props.similarity_range[id] !== null ? props.similarity_range[id] : ''} 
//                     // value={1.5} 
//                     onChange={props.inputHandlerSlider}
//                     style={{fontSize: '14px', border:'0.5px solid var(--aixelo-gray)', width:'60px'}}/>

// </>)


        let design_space = `[${factor.range_min}, ${factor.range_max}]`;
        return (<>
            <tr key={`factor_${id}`}>
                <td key={`factor_${id}`}>
                    <div style={{ fontSize: '14px' }}>
                        {factor.name}
                    </div>
                </td>
                <td key={`type_${id}`}>
                    <div style={{ fontSize: '14px' }}>
                        {factor.type}
                    </div>
                </td>
                <td key={`design_space_range_${id}`}>
                    <div style={{ fontSize: '14px' }}>
                        {design_space}
                    </div>
                </td>
                <td key={`similarity_range_field_${id}`}>
                    <div style={{ display:'flex', fontSize: '14px', alignItems: 'center' }}>
                        <span style={{marginRight:'5px'}}>&le;</span>
                        <input 
                            id={`similarity_range_field_${id}`}
                            type='number'  
                            placeholder='enter' 
                            autoComplete='false' 
                            value={props.similarity_range[id] !== null ? props.similarity_range[id] : ''} 
                            onChange={props.inputHandler}
                            style={{fontSize: '14px', border:'0.5px solid var(--aixelo-gray)', width:'60px'}}/>
                    </div>
                </td>
                <td key={`units_${id}`}>
                    <div style={{ fontSize: '14px' }}>
                        {factor.units}
                    </div>
                </td>
            </tr>
        </>);
    });



    return(<>
        <table style={{ tableLayout: 'auto' }}>
            <thead >
                {tableHead}
            </thead>
            <tr><div style={{height: '4px'}} colSpan={colNames.length}></div></tr>
            <tbody style={{border: '0.5px solid var(--aixelo-gray-light)'}}>
                {tableRows}
            </tbody>
        </table>
    </>
    );

}


export default SimilarityRangeTableEditor;
